import {computed, Injectable, signal} from '@angular/core';
import {DropdownOption} from '@shared/dropdown/dropdown.component';
import {distinctUntilChanged, Observable, Subject} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class TopBarService
{
    private readonly title = signal<string>('');

    private readonly showTopBar = signal<boolean>(true);

    private readonly showFilterArea = signal<boolean>(true);

    private readonly showInviteButton = signal<boolean>(false);

    private readonly showClinicsDropdown = signal<boolean>(false);

    public readonly showAddClinicButton = signal<boolean>(false);

    public readonly showAddCampaignButton = signal<boolean>(false);

    public readonly showAddSpecialityButton = signal<boolean>(false);

    private readonly selectedClinic = signal<DropdownOption>(undefined);

    private readonly selectedClinicChanged$: Subject<DropdownOption> = new Subject();

    private readonly buttonClicked$: Subject<void> = new Subject();
    
    public readonly getSelectedClinic = computed(() => this.selectedClinic());

    public readonly getTitle = computed(() => this.title());

    public readonly getShowTopBar = computed(() => this.showTopBar());

    public readonly getShowFilterArea = computed(() => this.showFilterArea());

    public readonly getShowInviteButton = computed(() => this.showInviteButton());

    public readonly getShowClinicsDropdown = computed(() => this.showClinicsDropdown());

    public readonly getShowAddClinicButton = computed(() => this.showAddClinicButton());

    public readonly getShowAddCampaignButton = computed(() => this.showAddCampaignButton());

    public readonly getShowAddSpecialityButton = computed(() => this.showAddSpecialityButton());

    public setTitle(title: string): void
    {
        this.title.set(title);
    }

    public setShowTopBar(value: boolean): void
    {
        this.showTopBar.set(value);
    }

    public setShowFilterArea(value: boolean): void
    {
        this.showFilterArea.set(value);
    }

    public setShowInviteButton(value: boolean): void
    {
        this.showInviteButton.set(value);
    }

    public setSelectedClinic(clinic: DropdownOption): void
    {
        this.selectedClinic.set(clinic);
        this.selectedClinicChanged$.next(clinic);
    }

    public setShowClinicsDropdown(value: boolean): void
    {
        this.showClinicsDropdown.set(value);
    }

    public setShowAddClinicButton(value: boolean): void
    {
        this.showAddClinicButton.set(value);
    }

    public setShowAddCampaignButton(value: boolean): void
    {
        this.showAddCampaignButton.set(value);
    }

    public setShowAddSpecialityButton(value: boolean): void
    {
        this.showAddSpecialityButton.set(value);
    }

    public emitClick(): void
    {
        this.buttonClicked$.next();
    }

    public onActionButtonClick(): Observable<void>
    {
        return this.buttonClicked$.asObservable();
    }

    public onSelectedClinicChanged(): Observable<DropdownOption>
    {
        return this.selectedClinicChanged$.asObservable().pipe(distinctUntilChanged());
    }
}
